import { createContext, useContext } from "react";

const AppContext = createContext();
export default AppContext;

export const useApp = () => useContext(AppContext);

export function withApp(Component) {
  return (props) => {
    return (
      <AppContext.Consumer>
        {(app) => <Component app={app} {...props} />}
      </AppContext.Consumer>
    );
  };
}
